import React from 'react';
import { Switch, Route, BrowserRouter as Router, Redirect } from 'react-router-dom';
import LoginPage from './sales-desk/login/LoginPage'
import MainPage from './sales-desk/MainPage';
import Signup from './sales-desk/signup/Signup';
import ForgotPassword from './sales-desk/login/ForgotPassword';
import ManagePro from './sales-desk/header/ManagePro';
import CreateNewProject from './sales-desk/projects/CreateNewProject';
import ProjectPlanSettings from './sales-desk/ProjectPlanSettings';
import { TermsAndCondition } from './sales-desk/projectmgmt/TermsAndCondition';

const Main = () => {
  return (
    <Router basename={window.contextPath}>
      <Switch>
        <Route exact path="/">
          <Redirect to="/projectmgmt" />
        </Route>
        <Route exact path='/terms-and-condition' component={TermsAndCondition}></Route>
        <Route exact path='/login' component={LoginPage}></Route>
        <Route path='/signup' component={Signup}></Route>
        <Route path='/forgotpassword' component={ForgotPassword}></Route>
        <Route path='/manage-projects' component={ManagePro}></Route>
        <Route path='/manage-projects' component={ManagePro}></Route>
        <Route path='/projectmgmt' component={MainPage}></Route>
        <Route path='/project-plan-settings' component={ProjectPlanSettings}></Route>
        <Route path='/projects/createNewProject' component={CreateNewProject}></Route>

      </Switch>
    </Router>
  );
}
export default Main;


// WEBPACK FOOTER //
// ./src/Main.js